import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class FrequentlyBoughtTogetherService extends BaseService {
    constructor() {
        super(apiroutes.FREQUENTLY_BOUGHT_TOGETHER);
    }

    async create(data) {
        return await super.customCall('POST', '', data, null, 'json');
    }

    async update(id, data) {
        return await super.customCall('PATCH', `/${id}`, data, null, 'json');
    }

    async delete(id) {
        return await super.delete(id);
    }

    async getAll(params = {}) {
        return await super.customCall('GET', '', null, params, null);
    }

    async getById(id) {
        return await super.getById(id);
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters);
    }
}

export default new FrequentlyBoughtTogetherService();
